import React, { useEffect, useState } from "react";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import { useTranslation } from "react-i18next";
import InputField from "../../components/shared/InputField";
import Button from "../../components/shared/Button";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import SelectField from "../../components/shared/SelectField";
import apiClient from "../../components/utils/apiClient";
import OTPTimer from "../../components/shared/OTPTimer";
import OTPInputField from "../../components/shared/OTPInputField";
import useToken from "../../components/helpers/useToken";
import useUser from "../../components/helpers/useUser";

const RegisterPage = () => {

  const {i18n,t} = useTranslation();
  useDocumentTitle('pageTitles.register');
  const navigate = useNavigate();
  const [isFormSubmitDisabled,setIsFormSubmitDisabled] = useState(true);
  const [isVerifyButtonDisabled,setIsVerifyButtonDisabled] = useState(true);
  const [signUpForm,setSignUpForm] = useState({name: '', email:'', mobile: '', companyName: '', numOfProperties: 1, companyAddress: '', password: '' });
  const [errors, setErrors] = useState(null);
  const [token, setToken] = useToken();
  const [user, setUser] = useUser();
  const [searchParams, setSearchParams] = useSearchParams();

  const [OTPValue, setOTPValue] = useState('');

  const [isEmailVerified, setIsEmailVerified] = useState(false);

  const { packageId } = useParams();

  const [isOTPSent, setIsOTPSent] = useState(false);
  const [isTimer , setIsTimer] = useState(false);

  const [isRegisteredFormValid, setIsRegisteredFormValid] = useState(true);

  const [businessPackage, setBusinessPackage] = useState(null);

  const [isCheckoutButtonDisabled, setIsCheckoutButtonDisabled] = useState(false);

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showFailureMessage, setShowFailureMessage] = useState(false);

  const generateUniqueId = () => {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }

  let timerKey = generateUniqueId();

  useEffect(()=>{
    if(signUpForm && signUpForm?.name && signUpForm.email && signUpForm.mobile && signUpForm.companyName && signUpForm.companyAddress && signUpForm.password) {
      setIsFormSubmitDisabled(false);
    } else {
      setIsFormSubmitDisabled(true);
    }
  },[signUpForm]);

  const hideError = (err) => {
    if(errors) {
      let errorsList = errors;
      delete errorsList[err];
      setErrors(errorsList);
    }
  }

  const getBusinessPackage = async () => {
    try {
      const response = await apiClient.get(`/b-packages/${packageId}`);
      if(response?.data) {
        setBusinessPackage(response?.data);
      }
    } catch(err) {}
  }

  useEffect(()=>{
    if(token !== undefined && token !== 'undefined' && token !== 'remove') {
      getBusinessPackage();
    }
  },[token])


  console.log(token);


  const handleClickSignUpButton = () => {
    setErrors(null);
    let errorsList = {};
    if(signUpForm?.name?.length < 2) {
      errorsList.name = 'validation.nameLength';
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(signUpForm?.email)) {
      errorsList.email = 'validation.invalidEmail';
    }
    if(!/^(5)([0-9]{8})$/.test(signUpForm?.mobile?.replace('+966',''))) {
      errorsList.mobile = 'validation.invalidmobile';
    }
    if(signUpForm?.companyName?.length < 2) {
      errorsList.companyName = 'validation.companyNameLength';
    }
    if(Object.keys(errorsList).length > 0) {
      setErrors(errorsList);
    } else {
      handleClickSignUpButtonAction();
    }
  }


  const handleClickSignUpButtonAction = async () => {
    setErrors(null);
    setIsFormSubmitDisabled(true);
    const finalSignUpForm = signUpForm;
    finalSignUpForm.numOfProperties =  parseInt(finalSignUpForm?.numOfProperties);
    try {
      const response = await apiClient.post(`/b-owners/register`,Object.fromEntries(Object.entries(finalSignUpForm).filter(([_, v]) => v !== '')));
      if(response?.data) {
        setToken(response?.data?.token);
        setUser(response?.data);
        setIsRegisteredFormValid(true);
      }
    } catch(err) {
      setIsFormSubmitDisabled(false);
      setIsRegisteredFormValid(false);
      let errorsList = {};
      if(err?.response?.data?.errors) {
        err?.response?.data?.errors?.map(err=>{
            errorsList[err.field] = err.message; 
        });
      }
      if (err?.response?.data?.category === 'companyNameUsed') {
        errorsList.companyName = 'validation.companyNameUsed';
      }
      setErrors(errorsList);
    }
  }

  const sendOTPToEmail = async () => {
    setIsFormSubmitDisabled(true);
     try {
      const response = await apiClient.post(`/b-users/send-email-verification-otp`,{email: signUpForm?.email});
      if(response?.data || response?.status === 204) {
        setIsOTPSent(true);
        setIsTimer(true);
        timerKey = generateUniqueId();
      }
    } catch(err) {
      setIsFormSubmitDisabled(false);
      setErrors(null);
      let errorsList = {};
      if (err?.response?.data?.category === 'EmailAlreadyUsed') {
        errorsList.email = 'validation.usedEmail';
      }
      setErrors(errorsList);
    }
  }

  useEffect(()=>{
    if(OTPValue && /^\d{4}$/.test(OTPValue)) {
      setIsVerifyButtonDisabled(false);
    } else {
      setIsVerifyButtonDisabled(true);
    }
  },[OTPValue])

  const VerifyOTP = async () => {
    try {
      const response = await apiClient.post(`/b-users/verify-email`,{email: signUpForm?.email, code: OTPValue});
      if(response?.data || response?.status === 204) {
        setIsEmailVerified(true);
        handleClickSignUpButtonAction();
      }
    } catch(err) {
      setIsFormSubmitDisabled(false);
      setErrors(null);
      let errorsList = {};
      if (err?.response?.data?.category === 'InvalidEmailVerificationCode') {
        errorsList.OTP = 'validation.invalidCode';
      }
      setErrors(errorsList);
    }

  }

  const getPackageName = (name) => {
    switch(name) {
      case 'Essential Care Plan':
        return 'خطة الرعاية الأساسية';
      case 'Pro Shield Plan':
        return 'خطة الرعاية المتقدمة';
      case 'Total Guard Plan':
        return 'خطة الرعاية الشاملة';
      default:
        return 'غير محدد';
    }
  }


  const handleClickCheckoutButton = async () => {
    setIsCheckoutButtonDisabled(true);
    let callback;
    callback =  window?.location?.href;
    try {
      const response = await apiClient.post(`/b-business/${user?.business?._id}/subscribe`,{
        "amount": businessPackage?.price,
        "frontEndCallback": callback,
        "packageId": businessPackage?._id
      });
      if(response?.data) {
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('b-user');
        window.location.href = response?.data?.formUrl;
        return false;
      }
    } catch(err) {}
  }


  useEffect(()=>{
    if(searchParams.get("status") && searchParams.get("status") === 'paid') {
      setShowSuccessMessage(true);
    }
    if(searchParams.get("status") && searchParams.get("status") !== 'paid') {
      setShowFailureMessage(true);
    }
  },[])

  if(showSuccessMessage) {
    navigate(`/${i18n.language}/account-success`);
  }

  if(showFailureMessage) {
    navigate(`/${i18n.language}/account-failure`);
  }


  if(isOTPSent && isEmailVerified && isRegisteredFormValid) {
    return (
      businessPackage ? <>
      <div className="absolute top-[0px] left-[0px] w-full h-full bg-grey-50 z-[-1]"></div>
      <div className="w-full pb-[30px]">
        <div className="select-none cursor-pointer font-[500] text-[18px] text-darkBlue leading-[25px] mt-[15px] mb-[25px] absolute top-[110px] right-[24px]" onClick={()=> window.location.href = 'https://staging-business.fanni.sa/packages.html'}><img src={'/assets/images/arrow-square-left.svg'} alt="" className="rotate-180 inline-block align-top me-[10px]" /> العودة للباقات</div>
        <div className="w-full max-w-[560px] bg-white rounded-[16px] p-[16px] overflow-hidden relative pb-[60px]">
          <h2 className="text-grey-900 font-[600] text-[32px] border-b-[1px] border-b-grey-200 pb-[15px]">تفاصيل الاشتراك</h2>
          <div className="pt-[15px] text-[18px] text-darkBlue font-[800]">
            <img src={'/assets/images/shield-tick-2.svg'} alt="" className="inline-block align-top me-[10px]" />
            خطتك المختارة
          </div>
          <h3 className="text-[24px] font-[700] text-darkBlue pt-[5px] pb-[15px]">{getPackageName(businessPackage?.name)}</h3>
          <div className="pt-[15px] text-[18px] text-darkBlue font-[800] border-t-[1px] border-t-grey-200">
            <img src={'/assets/images/empty-wallet.svg'} alt="" className="inline-block align-top me-[10px]" />
            السعر
          </div>
          <div className="pt-[5px] text-[26px] text-darkBlue font-[700]">
            <img src={'/assets/images/SAR.svg'} alt="" className="inline-block align-baseline me-[3px]" />
            {businessPackage?.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </div>
          <div className={`absolute bottom-[0] right-[0] left-[0] w-full h-[56px] leading-[56px] bg-blue text-white text-center cursor-pointer select-none font-[600] text-[16px] ${isCheckoutButtonDisabled ? 'opacity-50 cursor-default pointer-events-none' : ''}`} onClick={()=> isCheckoutButtonDisabled ? '' : handleClickCheckoutButton()}>
            ادفع
          </div>
        </div>
      </div>
      </> : ''
    )
  }

  if(isOTPSent && !isEmailVerified && isRegisteredFormValid) {
    return (
      <>
      <div className="absolute top-[0px] left-[0px] w-full h-full bg-grey-50 z-[-1]"></div>
      <div className="w-full pb-[30px]">
        <div className="select-none cursor-pointer font-[500] text-[18px] text-darkBlue leading-[25px] mt-[15px] mb-[25px]" onClick={()=> window.location.href = 'https://staging-business.fanni.sa/packages.html'}><img src={'/assets/images/arrow-square-left.svg'} alt="" className="rotate-180 inline-block align-top me-[10px]" /> العودة للباقات</div>
        <h3 className="text-grey-900 font-[600] text-[32px] leading-[48px]">التحقق من بريدك الإلكتروني.</h3>
        <p className="text-grey-600 font-[500] text-[18px] leading-[27px] mt-[15px] mb-[40px] max-w-[500px]">لقد أرسلنا إليك رمز التحقق إلى  
          <span className="text-grey-900">"{signUpForm?.email}"</span> 
          حتى تتمكن من تأكيد بريدك الإلكتروني.</p>
        <p className="text-grey-900 font-[500] text-[18px] leading-[27px]">إذا لم تستلم الرمز، يمكنك
          <span className={`inline-block mx-[5px] select-none ${isTimer ? 'text-grey-300' : 'text-blue cursor-pointer'}`} onClick={()=> !isTimer ?  sendOTPToEmail() : ''}>ارساله</span>
          {isTimer && <span className="inline-block">
           مره اخري بعد <OTPTimer key={timerKey} initialTime={59} onComplete={()=>setIsTimer(false)} />
          </span>}
        </p>
        <p className="text-[18px] font-[500] text-grey-900 mt-[20px]">الرجاء إدخال الرمز المرسل إلى بريدك الإلكتروني.</p>
        <div className="w-full lg:max-w-[450px] pt-[40px] pb-[35px] lg:pb-0">
          <div className="mb-[20px]">
              <OTPInputField onkeydown={(e)=>e.key === 'Enter' && (!isFormSubmitDisabled) && '' } label={t("forms.OTPLabel")} value={OTPValue} error={errors?.OTP} errorMessage={errors?.OTP} translateError={true} onChange={(otp)=>{ if(otp === '' || /^[0-9\b]+$/.test(otp)) { setOTPValue(otp) }; hideError('OTP')}} />
          </div>
          <div className="mb-[35px]">
              <Button type="button" text={'التحقق من الهوية'} disabled={isVerifyButtonDisabled} onClick={()=>VerifyOTP()} />
          </div>
        </div>
        <p className="text-grey-600 text-[18px] font-[500] leading-[27px] absolute bottom-[15px] end-[24px] start-[24px]">{t('registerPage.signinText')} <Link className="text-blue font-[700]" to={`/${i18n.language}/login`}>{t('registerPage.signin')}</Link>.</p>
      </div>
      </>
    )
  }


  return (
    <div className="w-full pb-[30px]">
      <div className="select-none cursor-pointer font-[500] text-[18px] text-darkBlue leading-[25px] mt-[15px] mb-[25px]" onClick={()=> window.location.href = 'https://staging-business.fanni.sa/packages.html'}><img src={'/assets/images/arrow-square-left.svg'} alt="" className="rotate-180 inline-block align-top me-[10px]" /> العودة للباقات</div>
      <h3 className="text-grey-900 font-[600] text-[32px] leading-[48px]">{t('registerPage.welcome')}</h3>
      <p className="text-grey-600 font-[500] text-[18px] leading-[27px] mt-[15px] mb-[40px]">{t('registerPage.subHead')}</p>
      <p className="text-grey-900 font-[500] text-[18px] leading-[27px]">{t('registerPage.formHead')}</p>
      <div className="w-full lg:max-w-[450px] pt-[40px] pb-[35px] lg:pb-0">
        <div className="mb-[20px]">
            <InputField label={t("forms.nameLabel")} placeholder={t("forms.namePlaceholder")} value={signUpForm?.name} error={errors?.name} errorMessage={errors?.name} translateError={true} onChange={(e)=>{setSignUpForm({ ...signUpForm, name: e.target.value }); hideError('name')}} />
        </div>
        <div className="mb-[20px]">
            <InputField label={t("forms.emailLabel")} placeholder={t("forms.emailPlaceholder")} value={signUpForm?.email} error={errors?.email} errorMessage={errors?.email} translateError={true} onChange={(e)=>{setSignUpForm({ ...signUpForm, email: e.target.value }); hideError('email')}} />
        </div>
        <div className="mb-[20px]">
            <InputField phone={true} label={t("forms.mobileLabel")} value={signUpForm?.mobile?.replace('+966','')} error={errors?.mobile} errorMessage={errors?.mobile} translateError={true} onChange={(e)=>{ if(e.target.value === '' || /^[0-9\b]+$/.test(e.target.value)) { setSignUpForm({ ...signUpForm, mobile: '+966'+e.target.value }) }; hideError('mobile')}} />
        </div>
        <div className="mb-[35px]">
            <InputField label={'كلمة المرور'} placeholder={'اكتب كلمة المرور'} type={'password'} value={signUpForm?.password} error={errors?.password} errorMessage={errors?.password} translateError={true} onChange={(e)=>{setSignUpForm({ ...signUpForm, password: e.target.value }); hideError('password')}} />
        </div>
        <div className="mb-[35px]">
            <InputField label={t("forms.companyNameLabel")} placeholder={t("forms.companyNamePlaceholder")} type={'companyName'} value={signUpForm?.companyName} error={errors?.companyName} errorMessage={errors?.companyName} translateError={true} onChange={(e)=>{setSignUpForm({ ...signUpForm, companyName: e.target.value }); hideError('companyName')}} />
        </div>
        <div className="mb-[20px]">
            <InputField label={'عنوان شركتك'} placeholder={'اكتب عنوان شركتك'} type={'companyAddress'} value={signUpForm?.companyAddress} error={errors?.companyAddress} errorMessage={errors?.companyAddress} translateError={true} onChange={(e)=>{setSignUpForm({ ...signUpForm, companyAddress: e.target.value }); hideError('companyAddress')}} />
        </div>
        <div className="mb-[35px]">
            <Button type="button" text={'أنشئ حساب'} disabled={isFormSubmitDisabled} onClick={()=> isOTPSent && isEmailVerified ? handleClickSignUpButtonAction() : sendOTPToEmail()} />
        </div>
      </div>
      <p className="text-grey-600 text-[18px] font-[500] leading-[27px] absolute bottom-[15px] end-[24px] start-[24px]">{t('registerPage.signinText')} <Link className="text-blue font-[700]" to={`/${i18n.language}/login`}>{t('registerPage.signin')}</Link>.</p>
    </div>
  );
};

export default RegisterPage;
